import React from 'react';
import {Route} from 'react-router-dom';

import * as Screens from './screens';

const routes = [
    <Route
        exact
        path="/administration/operating-procedures"
        component={Screens.List}
        key="operating-procedures"
    />,
    <Route
        exact
        path="/administration/operating-procedures/new"
        component={Screens.New}
        key="operating-procedures-new"
    />,
    <Route
        exact
        path="/administration/operating-procedures/:id/edit"
        component={Screens.Edit}
        key="operating-procedures-edit"
    />,
];

export default routes;
